import React from 'react';

interface Portfolio {
  NAV?: number;
  x1Day_ReturnsDollar?: number;
  x1Week_ReturnsDollar?: number;
  PortPnLDol?: number;
  BCT?: any[];
}

interface PortfolioSummaryProps {
  portfolios: Portfolio[];
}

const PortfolioSummary: React.FC<PortfolioSummaryProps> = ({ portfolios }) => {
  return (
    <div style={{ marginBottom: '2rem', backgroundColor: 'white', padding: '1.5rem', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1rem' }}>
        <div>
          <h2 style={{ color: '#1e1e1e', marginBottom: '0.5rem' }}>Total Portfolio Value</h2>
          <div style={{ fontSize: '2rem', fontWeight: '600', color: '#1e1e1e' }}>
            ${portfolios.reduce((total, p) => total + (p.NAV || 0), 0).toLocaleString()}
          </div>
        </div>
        <div style={{ 
          backgroundColor: '#f0f9ff', 
          padding: '0.75rem 1rem', 
          borderRadius: '0.5rem',
          textAlign: 'center'
        }}>
          <div style={{ color: '#0369a1', fontSize: '0.875rem', marginBottom: '0.25rem' }}>Active Portfolios</div>
          <div style={{ color: '#0369a1', fontSize: '1.5rem', fontWeight: '600' }}>{portfolios.length}</div>
        </div>
      </div>
      
      {/* Aggregate Performance */}
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
        gap: '1.5rem',
        padding: '1rem',
        backgroundColor: '#f8fafc',
        borderRadius: '0.5rem'
      }}>
        <div>
          <div style={{ fontSize: '0.875rem', color: '#64748b', marginBottom: '0.25rem' }}>Today's Change</div>
          <div style={{ 
            color: portfolios.reduce((sum, p) => sum + (p.x1Day_ReturnsDollar || 0), 0) > 0 ? '#10B981' : '#EF4444',
            fontSize: '1.125rem',
            fontWeight: '500'
          }}>
            ${portfolios.reduce((sum, p) => sum + (p.x1Day_ReturnsDollar || 0), 0).toFixed(2)}
          </div>
        </div>
        <div>
          <div style={{ fontSize: '0.875rem', color: '#64748b', marginBottom: '0.25rem' }}>Week's Change</div>
          <div style={{ 
            color: portfolios.reduce((sum, p) => sum + (p.x1Week_ReturnsDollar || 0), 0) > 0 ? '#10B981' : '#EF4444',
            fontSize: '1.125rem',
            fontWeight: '500'
          }}>
            ${portfolios.reduce((sum, p) => sum + (p.x1Week_ReturnsDollar || 0), 0).toFixed(2)}
          </div>
        </div>
        <div>
          <div style={{ fontSize: '0.875rem', color: '#64748b', marginBottom: '0.25rem' }}>Total P/L</div>
          <div style={{ 
            color: portfolios.reduce((sum, p) => sum + (p.PortPnLDol || 0), 0) > 0 ? '#10B981' : '#EF4444',
            fontSize: '1.125rem',
            fontWeight: '500'
          }}>
            ${portfolios.reduce((sum, p) => sum + (p.PortPnLDol || 0), 0).toFixed(2)}
          </div>
        </div>
        <div>
          <div style={{ fontSize: '0.875rem', color: '#64748b', marginBottom: '0.25rem' }}>Total Holdings</div>
          <div style={{ 
            color: '#1e1e1e',
            fontSize: '1.125rem',
            fontWeight: '500'
          }}>
            {portfolios.reduce((sum, p) => sum + (Array.isArray(p.BCT) ? p.BCT.length : 0), 0)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortfolioSummary;
